import React from 'react'

import ElegibilidadFormView from './Elegibilidad'
import { ElegibilidadProvider } from '../../../../context/ElegibilidadContext'
import { EligibilityContextProvider } from '../../../../context/EligibilityContext'
import { useLocation } from 'react-router-dom'
// import { FormContextProvider } from '../../../../context/formContext'
// import Toast from '../../../../components/Toast/Toast'
const FormElegibilidadView = () => {
  const location = useLocation()
  return (
    <EligibilityContextProvider>
      <ElegibilidadProvider>
        <ElegibilidadFormView idForm={location.state} />
      </ElegibilidadProvider>
    </EligibilityContextProvider>
  )
}

export default FormElegibilidadView
